import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/ListagemClientes.css";

const ListagemClientes = () => {
  const navigate = useNavigate();

  const [filtros, setFiltros] = useState({
    razao_social: "",
    cnpj: "",
    uf: "",
    cidade: ""
  });

  const [clientes, setClientes] = useState([]);

  const ufs = ["", "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"];

  const handleFiltroChange = (e) => {
    const { name, value } = e.target;
    setFiltros({ ...filtros, [name]: value });
  };

  const handleBuscar = async () => {
    try {
      const queryParams = new URLSearchParams(
        Object.fromEntries(
          Object.entries(filtros).filter(([_, v]) => v.trim() !== "")
        )
      ).toString();

      const response = await fetch(`http://localhost:5000/api/clientes?${queryParams}`);
      const data = await response.json();
      setClientes(data);
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
      alert("Erro ao buscar clientes. Veja o console.");
    }
  };

  const handleLimpar = () => {
    setFiltros({ razao_social: "", cnpj: "", uf: "", cidade: "" });
    setClientes([]);
  };

  const excluirCliente = async (id) => {
    if (!window.confirm("Tem certeza que deseja excluir este cliente?")) return;

    try {
      const response = await fetch(`http://localhost:5000/api/clientes/${id}`, {
        method: "DELETE",
      });

      if (response.ok) {
        setClientes((prev) => prev.filter((c) => c.id !== id));
      } else {
        const erro = await response.json();
        alert("Erro ao excluir: " + (erro.mensagem || erro.erro || "Erro desconhecido"));
      }
    } catch (error) {
      console.error("Erro ao excluir cliente:", error);
      alert("Erro ao excluir cliente. Veja o console.");
    }
  };

  const irParaCadastro = () => {
    navigate("/cadastro-cliente");
  };

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Gestão de Clientes</h2>

      <div className="filtros">
        <input
          type="text"
          name="razao_social"
          placeholder="Razão Social"
          value={filtros.razao_social}
          onChange={handleFiltroChange}
        />

        <input
          type="text"
          name="cnpj"
          placeholder="CNPJ"
          value={filtros.cnpj}
          onChange={handleFiltroChange}
        />

        <input
          type="text"
          name="cidade"
          placeholder="Cidade"
          value={filtros.cidade}
          onChange={handleFiltroChange}
        />

        <select name="uf" value={filtros.uf} onChange={handleFiltroChange}>
          {ufs.map((uf) => (
            <option key={uf} value={uf}>{uf || "UF"}</option>
          ))}
        </select>

        <div className="acoes-filtro">
          <button onClick={handleBuscar}>🔍 Filtrar</button>
          <button onClick={handleLimpar}>🧹 Limpar</button>
          <button onClick={irParaCadastro}>➕ Adicionar Cliente</button>
        </div>
      </div>

      <table className="tabela-clientes" style={{ fontSize: "0.65rem" }}>
        <thead>
          <tr>
            <th style={{ width: "49%" }}>Razão Social</th>
            <th style={{ width: "20%" }}>CNPJ</th>
            <th style={{ width: "7%" }}>UF</th>
            <th style={{ width: "25%" }}>Cidade</th>
          </tr>
        </thead>
        <tbody>
          {clientes.length === 0 ? (
            <tr>
              <td colSpan="5">Nenhum cliente encontrado.</td>
            </tr>
          ) : (
            clientes.map((cliente, index) => (
              <tr key={index}>
                <td>
                 <span
                     onClick={() => navigate(`/cliente/${cliente.id}`)}
                     style={{ cursor: "pointer", color: "#0057b8", textDecoration: "underline" }}
                  >
                    {cliente.razao_social}
                  </span>
                </td>
                <td>{cliente.cnpj}</td>
                <td>{cliente.uf}</td>
                <td>{cliente.cidade}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ListagemClientes;
